import { Box, TextField, Typography } from "@mui/material";
import { getInputLabelProps, getInputProps } from "../../../../common/Utils";
import { useEffect, useState } from "react";
import styles from './InputTextField.module.scss';
import { InputFieldProps } from "../../../../common/Interfaces";

export default function InputTextFieldMultiline ({id, 
                                                  maximumCharacters, 
                                                  label, 
                                                  value, 
                                                  handleValueChange, 
                                                  lineRows, 
                                                  errorMessage, 
                                                  onKeyPress, 
                                                  isReadOnly}: InputFieldProps){
    const [currentLength, setCurrentLength] = useState<number>(0);

    useEffect(() => {
        if(value){
            setCurrentLength(value.length);
            return;
        }

        setCurrentLength(0);
    }, [value]);

    return (
        <Box>
            <TextField
                id={id}
                name={id}
                size="small"
                inputProps={{
                    ...getInputProps(),
                    maxLength: maximumCharacters,
                    readOnly: isReadOnly,
                }}
                InputLabelProps={getInputLabelProps()}
                label={label}
                variant="outlined"
                value={value}
                onChange={handleValueChange}
                fullWidth
                multiline
                rows={lineRows ?? 3}
                helperText={`${currentLength}/${maximumCharacters}`}
                error={!!errorMessage}
                onKeyUp={onKeyPress}
            />
            {errorMessage && (<Typography className={styles.errorText}>
                {errorMessage}
            </Typography>)}
        </Box>
        
    );
}